module.exports = __webpack_public_path__ + "static/media/fa-brands-400.65b96d56.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-brands-400.woff2
// module id = 729
// module chunks = 0